import { HistoryView } from "@/components/HistoryView";

export default function Historial() {
  return (
    <div className="px-4 pt-5">
      <h1 className="font-display text-2xl font-semibold tracking-tight">Historial</h1>
      <p className="mt-1 mb-4 text-sm text-slate-500">Tus registros de temperatura.</p>
      <HistoryView isAdmin={false} />
    </div>
  );
}
